import { render, staticRenderFns } from "./commonMoralList.vue?vue&type=template&id=a31eb0e2&scoped=true"
import script from "./commonMoralList.vue?vue&type=script&lang=js"
export * from "./commonMoralList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31eb0e2",
  null
  
)

export default component.exports